import { FiTaskV2AssigneesHelper } from './../../../fi-task-v2-assignees-helper';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask2ReportItem } from '../../fi-task-v2-report';
import { AppTextService } from '@fi-shared/app-text';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { FiTooltipContentType } from '@fi-shared/fi-tooltip/fi-tooltip-enums';
import { FiTaskV2ReportAssigneesCellType } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-enums';

@Component({
    selector: 'fi-task-v2-report-assignees-cell',
    templateUrl: './fi-task-v2-report-assignees-cell.component.html',
    styleUrls: ['./fi-task-v2-report-assignees-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-report-assignees-cell' },
    standalone: false,
})
export class FiTaskV2ReportAssigneesCellComponent implements OnInit {
    @Input({ required: true }) taskReport: ITask2ReportItem;
    @Input({ required: true }) cellType: FiTaskV2ReportAssigneesCellType;
    protected fiTaskV2AssigneesHelper: FiTaskV2AssigneesHelper;
    protected readonly FiInfoIconMode = FiInfoIconMode;

    constructor(
        private appTextService: AppTextService,
        private sharedActionsService: SharedActionsBaseService,
    ) {}

    public ngOnInit(): void {
        this.fiTaskV2AssigneesHelper = new FiTaskV2AssigneesHelper(
            this.appTextService,
            this.taskReport.AccessRightFilterCollection,
            this.taskReport.AssignedUsers,
            this.taskReport.AssignmentType,
        );
    }

    private hasAssignedUsers(): boolean {
        return this.taskReport.AssignedUsers.length > 0;
    }

    protected showNoAssignedUsersText(): boolean {
        if (this.hasAssignedUsers()) {
            return false;
        }

        if (this.cellType === FiTaskV2ReportAssigneesCellType.ListAssignedTo) {
            return true;
        }

        if (this.cellType === FiTaskV2ReportAssigneesCellType.DetailsAssignedTo) {
            return !this.fiTaskV2AssigneesHelper.isRoleUnitAssignees;
        }

        if (this.cellType === FiTaskV2ReportAssigneesCellType.DetailsStaffInRolesUnits) {
            return true;
        }
        return false;
    }

    protected showRoleUnitAssignees(): boolean {
        if (this.cellType === FiTaskV2ReportAssigneesCellType.DetailsStaffInRolesUnits) {
            return false;
        }

        return this.fiTaskV2AssigneesHelper.isRoleUnitAssignees;
    }

    protected showUserAssignees(): boolean {
        if (this.cellType === FiTaskV2ReportAssigneesCellType.DetailsStaffInRolesUnits) {
            return true;
        }

        return !this.fiTaskV2AssigneesHelper.isRoleUnitAssignees;
    }

    protected showAssignToCurrentLocationInfo(): boolean {
        return !this.showNoAssignedUsersText() && this.showRoleUnitAssignees();
    }

    protected openUserDetails($event: MouseEvent, userId: number): void {
        $event.stopPropagation();
        $event.preventDefault();
        this.sharedActionsService.openUserViewPopup(userId);
    }

    protected openUnitDetails($event: MouseEvent, unitId: number): void {
        $event.stopPropagation();
        $event.preventDefault();
        this.sharedActionsService.openUnitViewPopup(unitId);
    }

    protected readonly FiTooltipContentType = FiTooltipContentType;
    protected readonly FiTaskV2ReportAssigneesCellType = FiTaskV2ReportAssigneesCellType;
}
